import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';
import { SUPPORT_ACCOUNT_EMAIL } from '@hotjar/webapp/constants/support';
import { Button, Checkbox, Modal, Text } from '@hotjar/hotsauce';
import { noop } from '@hotjar/webapp/lib/function';

const StyledCheckbox = styled(Checkbox)`
  display: block;
  text-transform: none;
`;

const grantSupportAccess = (accountId: number, organizationId: number) =>
  axios.put(`/api/v1/accounts/${accountId}/organizations/${organizationId}/invitations/support`);

interface SupportAccessModalProps {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
  accountId: number;
  organizationId: number;
}

export const SupportAccessModal = ({
  isOpen,
  onSubmit,
  onClose,
  accountId,
  organizationId,
}: SupportAccessModalProps): JSX.Element => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(true);

  const handleSubmit = async () => {
    if (isChecked) {
      grantSupportAccess(accountId, organizationId)
        .catch(noop)
        .finally(() => onSubmit());
    } else {
      onSubmit();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentLabel={t('core:primary.help.support-access.content-label')}
    >
      <Modal.Header title={t('core:primary.help.support-access.title')} />
      <Modal.Body>
        <StyledCheckbox
          id="grant-support-access"
          name="support_access"
          isChecked={isChecked}
          onChange={() => setIsChecked((prevIsChecked) => !prevIsChecked)}
          labelContent={t('core:primary.help.support-access.checkbox-label')}
        />
        <Text textType="caption" textColor="text_light">
          {t('core:primary.help.support-access.checkbox-description', {
            supportEmail: SUPPORT_ACCOUNT_EMAIL,
          })}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleSubmit}>
          {t('core:primary.help.support-access.primary-action')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
